import React from "react";
import PageBanner from "./pageBanner/PageBanner";
import Content from "carbon-react/lib/components/content";

const CenteredContent = (props) => {
  return <Content align="center">{props.children}</Content>;
};

const ErrorBanner = () => {
  return (
    <PageBanner id="error-banner" title="Oops!">
      <CenteredContent>
        An unexpected error occurred. More information may be available via the
        console.
      </CenteredContent>
    </PageBanner>
  );
};

export default ErrorBanner;
